import { render } from "./OceaniaView.vue?vue&type=template&id=14d7501a"
import script from "./OceaniaView.vue?vue&type=script&lang=js"
export * from "./OceaniaView.vue?vue&type=script&lang=js"

import "./OceaniaView.vue?vue&type=style&index=0&id=14d7501a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__